import { resolveColor } from "@insite/mobius/utilities";
import { IconOffset } from "@store/Framework/Types/Icon";
import { css, FlattenInterpolation } from "styled-components";

export const iconScalableStyles = (size = "1em", offset?: IconOffset | false) => {
    const inline = typeof offset !== "boolean";

    return css`
        position: relative;
        width: auto;
        height: ${inline ? "auto" : 0};
        ${offset ? "overflow: hidden;" : null}

        svg {
            width: ${size};
            height: ${size};
            ${() => {
                if (offset && (offset.vertical || offset.horizontal)) {
                    const vertical = offset.vertical ? `calc(-${size} * (${offset.vertical} / 100))` : "0";
                    const horizontal = offset.horizontal ? `calc(-${size} * (${offset.horizontal} / 100))` : "0";
                    return `margin: ${vertical} ${horizontal};`;
                }
            }}
        }
    `;
};

export const iconOffsetStyles = (
    offset?: string | null,
    spacing?: string | null,
    position: "left" | "right" = "left",
) => {
    if (!offset && !spacing) {
        return null;
    }

    const _position = position === "left" ? "right" : "left";
    const _spacing = offset && spacing ? `calc(${spacing} - ${offset})` : offset ? `-${offset}` : spacing;

    return css`
        ${offset ? `margin-${position}: -${offset};` : null}
        margin-${_position}: ${_spacing};
    `;
};

export const iconColorStyles = (color: string, transition: string | FlattenInterpolation<any> = "inherit") => {
    return css`
        ${({ theme }) => {
            const _color = resolveColor(color, theme);

            return css`
                color: ${_color};
                transition: ${_color === "inherit" || _color === "unset" ? "none" : transition};
            `;
        }}
    `;
};
